<template lang="pug">
    v-form(ref="groupForm" id="groupForm" @submit.prevent="doSave" lazy-validation)
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg3 md3 xs12 v-if="isUpdate")
                    v-text-field(dense v-model="group.corporateGroupId" label="Kode Group" readonly)
                v-flex(lg4 md4 xs12)
                    v-text-field(dense v-model="group.corporateGroupName" label="Nama Group" :rules="[v => !!v || 'Input Nama Group']" required)
                v-flex(lg3 md3 xs12)
                    f-decimalbox(v-model="group.limitTransaction" label="Limit Transaksi" :rules="[v => !!v || 'Input Limit Transaksi']" required)
            div(justify-center style="text-align: center" class="ma-2 menu-btn")
                v-btn(@click="doCancel" class="mx-1") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="groupForm") Simpan
                    v-icon mdi-content-save-outline
</template>
<script>
export default {
    name: "FGroupForm",
    props: ["isUpdate", "dataGroup"],
    data() {
        return {
            group: {
                corporateId: "",
                corporateGroupId: null,
                corporateGroupName: "",
                limitTransaction: 0
            }
        }
    },
    watch: {
        dataGroup(val){
            this.doInit(val);
        }
    },
    mounted() {
        this.doInit(this.dataGroup);
        
    },
    methods: {
        doInit(values){
            this.group = values ? values : {
                corporateId: "",
                corporateGroupId: null,
                corporateGroupName: "",
                limitTransaction: 0
            }
            if (this.$refs.groupForm) {
                this.$refs.groupForm.resetValidation();
            }
        },
        doSave(){
            if (this.$refs.groupForm.validate()) {
                this.$refs.groupForm.resetValidation();
                this.$emit("group", this.group);
            }
        },
        doCancel(){
            this.$refs.groupForm.resetValidation();
            this.$emit("cancel");
        }
    },
}
</script>